const calc = document.querySelector('.calculator.search.sticc');
if (calc) {
  // Show
  calc.classList.add('is-visible');

  // Hide
  calc.classList.remove('is-visible');
}




// Scroll event to add/remove "top-180" class
$(document).scroll(function() {
  var myID = document.getElementById("header_calc");

  // Check if the element exists before adding scroll event
  if (myID) {
    window.addEventListener("scroll", function() {
      if (window.scrollY >= 1) {
        myID.classList.add("top-180");
      } else {
        myID.classList.remove("top-180");
      }
    });
  } else {
    console.warn('Element with ID "header_calc" not found.');
  }
});

// Search button click handler
$(document).on("click", "#search", function(e) {
  e.preventDefault();
  
  // Get license plate input and its parent item
  let t = $(this).prev("#license");
  let o = t.val().replace(/ /g, "");  // Remove spaces
  let r = t.parents(".item");

  // Function to handle errors
  $("<div>").addClass("error");
  
  function setError(message) {
    r.attr("data-error", message);
  }

  // Function to toggle loading state
  function toggleLoading(loading = false) {
    r.toggleClass("loading", loading);
  }

  // If the license plate length is valid, make an API request
  if (o.length >= 3 && o.length <= 7) {
    toggleLoading(true);  // Show loading state
    $.get("https://touchpoint1.jb-digitals.com/", { reg: o })
      .done(function(response) {
        // Parse the JSON response
        response = JSON.parse(response);

        // If there are errors in the response, show error message
        if (response.hasOwnProperty("errors")) {
          toggleLoading(false);  // Hide loading state
          setError(response.errors[0].title);
        } else if (response.hasOwnProperty("colour") && response.hasOwnProperty("make")) {
          // Redirect if vehicle data is found
          let colour = response.colour;
          let make = response.make;
          let year = response.yearOfManufacture;
          window.location.href = `/pages/results?reg=${o}&make=${make}&color=${colour}&year=${year}`;
          r.attr("data-error", null);
        } else {
          toggleLoading(false);  // Hide loading state
          setError("No Vehicles!");
        }
      })
      .fail(function(error, textStatus) {
        toggleLoading(false);  // Hide loading state
        console.log("Request failed: " + textStatus);
      });
  }
});

// EasySearch event listener
(function() {
  document.addEventListener('easysearch_init_native_search_page', function() {
    easysearch.saveSearchParamsNATIVE = easysearch.saveSearchParams;
    easysearch.saveSearchParams = function(el) {
      return easysearch.saveSearchParamsNATIVE(el, true);
    };
  });
})();

(function() {
  function tryAttach() {
    const $section = $('[data-section-type="collection"]');
    const instance = $section.data('section');

    if (instance && typeof instance._showFiltersModal === 'function') {
      console.log('✅ Collection section instance found — attaching filter button handler.');
      $('[data-productgrid-trigger-filters]').off('click.custom').on('click.custom', function(e) {
        e.preventDefault();
        console.log('📂 Triggering theme’s _showFiltersModal()...');
        instance._showFiltersModal(e);
      });
      return true;
    }
    return false;
  }

  // Keep checking until found
  let tries = 0;
  const maxTries = 20;
  const timer = setInterval(function() {
    if (tryAttach() || tries++ >= maxTries) {
      clearInterval(timer);
    }
  }, 500);
})();




(function(){
  const INIT_FLAG = '__variantWireInit__';

  function fmtMoney(cents){
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, Shopify.money_format || "£{{amount}}");
      }
    } catch(e){}
    return "£" + (Number(cents||0)/100).toFixed(2);
  }

  function initVariantWire(root=document){
    const forms = [...root.querySelectorAll('form[action*="/cart/add"]')];
    if (!forms.length) return;

    forms.forEach(form=>{
      if (form[INIT_FLAG]) return;
      form[INIT_FLAG] = true;

      const priceEl = form.closest('[data-product]')?.querySelector('[data-product-price], .product__price, .price-item--regular, .price')
                      || form.querySelector('[data-product-price], .product__price, .price-item--regular, .price');
      const selectId = form.querySelector('select[name="id"]');
      const radios = [...form.querySelectorAll('input[type="radio"][name="Title"]')];

      const handle = (location.pathname.match(/\/products\/([^\/\?]+)/)||[])[1];
      if (!handle) return;

      fetch(`/products/${handle}.js`)
        .then(r=>r.json())
        .then(product=>{
          const map = Object.fromEntries((product.variants||[]).map(v => [String(v.option1).trim(), v]));

          const getLabel = r => (form.querySelector(`label[for="${r.id}"]`)?.textContent || r.value || "").trim();

          function applyVariantByLabel(label){
            const v = map[String(label).trim()];
            if (!v) return;

            let idField = selectId;
            if (!idField) {
              idField = form.querySelector('input[name="id"]');
              if (!idField) {
                idField = document.createElement('input');
                idField.type = 'hidden';
                idField.name = 'id';
                form.appendChild(idField);
              }
            }

            idField.value = String(v.id);
            idField.dispatchEvent(new Event('change', {bubbles:true}));

            if (priceEl) priceEl.textContent = fmtMoney(v.price);

            const atcBtn = form.querySelector('[type="submit"], button[name="add"]');
            if (atcBtn){
              atcBtn.disabled = v.available === false;
              atcBtn.setAttribute('aria-disabled', v.available === false ? 'true' : 'false');
            }

            document.dispatchEvent(new CustomEvent('variant:change', {detail:{variant:v}}));
          }

          radios.forEach(radio=>{
            const label = getLabel(radio);
            radio.addEventListener('change', ()=>applyVariantByLabel(label), {capture:true});
          });

          const checked = radios.find(r=>r.checked);
          if (checked) {
            applyVariantByLabel(getLabel(checked));
          } else if (radios.length) {
            applyVariantByLabel(getLabel(radios[0]));
          }
        })
        .catch(err => console.warn('[variant-wire] failed to load product JSON', err));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVariantWire(document));
  } else {
    initVariantWire(document);
  }

  document.addEventListener('shopify:section:load', (e)=> initVariantWire(e.target));
  document.addEventListener('shopify:section:render', (e)=> initVariantWire(e.target));
})();




/* === Force-open filters on mobile so we discover the drawer === */

/*
(function forceOpenAnyFilter(){
  console.clear();

  const btn = document.querySelector('.utils-filter-button');
  if (!btn) { console.warn('[filter] No .utils-filter-button found'); return; }
  console.log('[filter] Toggle:', btn);

  const candidates = [...document.querySelectorAll('aside,div,section,dialog,details')]
    .filter(el => {
      const idc = (el.id + ' ' + el.className).toLowerCase();
      const data = JSON.stringify(el.dataset||{}).toLowerCase();
      return /filter|facet|drawer|offcanvas|sheet|util/.test(idc + ' ' + data);
    });

  if (!candidates.length) {
    console.warn('[filter] No obvious candidates in DOM.');
  } else {
    console.log('[filter] Candidates:', candidates.length, candidates.slice(0,8));
  }

  function outline(el, color='red'){
    try {
      el.style.outline = `3px solid ${color}`;
      el.style.outlineOffset = '0';
    } catch(e){}
  }

  function pickDrawer(){
    const ac = btn.getAttribute('aria-controls');
    if (ac && document.getElementById(ac)) return document.getElementById(ac);

    const near = btn.closest('main,section,div,body')?.querySelector(
      'details[id*="filter" i], details[class*="filter" i], ' +
      '[role="dialog"][aria-label*="filter" i], .filter-drawer, .filters-drawer, ' +
      '.facets-drawer, .mobile-facets, [data-drawer="filters"], [data-filters-drawer], ' +
      '[data-productgrid-filters], [data-productgridDrawerFilters], ' +
      'aside[id*="filter" i], div[id*="filter" i]'
    );
    if (near) return near;

    return candidates[0] || null;
  }

  function openDrawer(drawer){
    if (!drawer) {
      window.dispatchEvent(new CustomEvent('productgrid:filters:open'));
      document.dispatchEvent(new CustomEvent('productgrid:filters:open'));
      console.warn('[filter] No drawer found, fired custom events instead');
      return;
    }

    const tag = drawer.tagName.toLowerCase();
    outline(drawer, 'red');

    drawer.removeAttribute('hidden');
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden','false');
    drawer.style.display = 'block';
    drawer.style.opacity = '1';
    drawer.style.pointerEvents = 'auto';
    drawer.style.visibility = 'visible';
    drawer.style.transform = 'none';

    drawer.classList.remove('hidden','is-hidden','u-hidden','closed','is-closed');
    drawer.classList.add('open','is-open','active','drawer--open','facets--open','utils-filters--open');

    if (tag === 'details') drawer.setAttribute('open','open');

    document.documentElement.classList.add('no-scroll','overflow-hidden');
    document.body.classList.add('no-scroll','overflow-hidden');

    const inners = drawer.querySelectorAll('[style*="translate"],[class*="translate"],[class*="offcanvas"],[class*="drawer"],[class*="sheet"]');
    inners.forEach(n => {
      n.style.transform = 'none';
      n.classList.remove('is-closed','closed');
      n.classList.add('is-open','open','active');
    });

    console.log('[filter] FORCED OPEN:', drawer);
  }

  const drawer = pickDrawer();
  console.log('[filter] Picked drawer:', drawer);
  if (drawer) outline(drawer);

  const tap = (e)=>{ if (e.type!=='click') e.preventDefault(); openDrawer(drawer); };
  btn.addEventListener('click', tap, {capture:true});
  btn.addEventListener('pointerup', tap, {capture:true});
  btn.addEventListener('touchend', tap, {passive:false, capture:true});

  openDrawer(drawer);

  console.table((candidates.slice(0,10)).map(el => ({
    tag: el.tagName,
    id: el.id,
    class: el.className,
    data: JSON.stringify(el.dataset||'')
  })));
})();
*/